import { z } from 'zod';

export const uiActionTargetSchema = z.enum(['level-mapping', 'job-architecture-setup', 'job-architecture-board']);

const uiActionFields = {
    action: z.literal('navigate'),
    autoRun: z.boolean().default(false),
    blockId: z.string(),
    label: z.string(),
    type: z.literal('ui-action'),
};

const jobArchitectureParamsSchema = z.object({ jobArchitectureId: z.string() });

export const uiActionBlockSchema = z.discriminatedUnion('target', [
    z.object({
        ...uiActionFields,
        params: z.object({ architectureId: z.string(), runId: z.string().nullish() }),
        target: uiActionTargetSchema.extract(['level-mapping']),
    }),
    z.object({
        ...uiActionFields,
        params: jobArchitectureParamsSchema,
        target: uiActionTargetSchema.extract(['job-architecture-setup']),
    }),
    z.object({
        ...uiActionFields,
        params: jobArchitectureParamsSchema,
        target: uiActionTargetSchema.extract(['job-architecture-board']),
    }),
]);

export type UiActionBlock = z.infer<typeof uiActionBlockSchema>;
